import { Component, Element, Listen, Prop } from '@stencil/core';
import { createModalComponent } from '~service/modal-service';

@Component({
  tag: 'mama-wegweiser-starter',
})
export class MamaWegweiserStarter {
  @Element() el!: HTMLElement;

  @Prop() category: string;
  @Prop() header: string = '';
  @Prop() subheader: string = '';

  @Listen('click')
  openModal() {
    createModalComponent('mama-wegweiser', {
      category: this.category,
      header: this.header,
      subheader: this.subheader,
    });
  }
}
